import { ItemTags } from './models/AB-testing.models';
import { ABTestingService } from './services/AB-testing.service';

import { MocacoAttributesPublicModels } from '@features/products/mocaco-attributes';

// TESTAB ECOMDUTI-14561 TEST A/B - Etiquetas artículos
// PRIVATE
export const checkConditionsItemTags = (itemTags: ItemTags, isCategoryPage: boolean): boolean => {
    let result = false;
    if (itemTags.ignoreTags.length) {
        const categoryCond: boolean = isCategoryPage && itemTags.location.categoryPage;
        const productCond: boolean = !isCategoryPage && itemTags.location.productPage;

        if (categoryCond || productCond) result = true;
    }

    return result;
};

// TESTAB ECOMDUTI-14561 TEST A/B - Etiquetas artículos
// PUBLIC
export const filterMocacoAttrByABTest = (
    abTestingService: ABTestingService,
    mocacoAttr: MocacoAttributesPublicModels.PublicMocacoAttribute[],
    isCategoryPage: boolean
): MocacoAttributesPublicModels.PublicMocacoAttribute[] => {
    let mocacoAttrResult: MocacoAttributesPublicModels.PublicMocacoAttribute[] = mocacoAttr;

    const itemTags: ItemTags = abTestingService.getItemTags();
    const applyFilter: boolean = checkConditionsItemTags(itemTags, isCategoryPage);

    if (applyFilter) {
        if (itemTags.ignoreTags[0] === 'ALL_TAGS') {
            mocacoAttrResult = [];
        } else {
            mocacoAttrResult = mocacoAttr?.filter(
                (attr: MocacoAttributesPublicModels.PublicMocacoAttribute) => !itemTags.ignoreTags.some(
                    tag => tag === attr.name
                )
            );
        }
    }

    return mocacoAttrResult;
};
